import { AfterViewInit, Component, Inject } from '@angular/core';

import { Subject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { UserService } from '../../user/services/user.service';

import { TypeResponsabilite } from '../../../perimetres/entities/type-responsabilite.entity';

const typeResponsabiliteCac: TypeResponsabilite = 'CAC';
const typeResponsabiliteCc: TypeResponsabilite = 'CC';
	
@Component({
	selector: 'transfert-responsabilite',
	templateUrl: 'transfert-responsabilite.html',
	styleUrls: ['transfert-responsabilite.css'],
})
export class TransfertResponsabiliteComponent implements AfterViewInit {

	defaultTabIndex: number = 0;
	refreshCacTabCommand = new Subject<TypeResponsabilite>();
	refreshCcTabCommand = new Subject<TypeResponsabilite>();
	isUserCacOnAtLeastOneOuvrage!: boolean;
	isUserCcOnAtLeastOneOuvrage!: boolean;
	
	constructor(@Inject(UserService) private userService: UserService) {

	}

	ngAfterViewInit() {
		this.userService.getCurrentUserTLR().subscribe(
			(user) => {
				let isCac$ = this.userService.isUserCacOnAtLeastOneOuvrage(user.id);
				let isCc$ = this.userService.isUserCcOnAtLeastOneOuvrage(user.id);
				let userResponsibilities$ = combineLatest([isCac$, isCc$]).pipe(
					map(
						([isCac, isCc]) => {
							return {isCac: isCac, isCc: isCc};
						}
					)
				);
				userResponsibilities$.subscribe(
					(userResponsibilities) => {
						if (!userResponsibilities.isCac && userResponsibilities.isCc) {
							this.defaultTabIndex = 1;
						}
						this.isUserCacOnAtLeastOneOuvrage = userResponsibilities.isCac;
						this.isUserCcOnAtLeastOneOuvrage = userResponsibilities.isCc;
						if (userResponsibilities.isCc) {
							this.refreshCacTabCommand.next(typeResponsabiliteCc);
						}
						if (userResponsibilities.isCac) {
							this.refreshCacTabCommand.next(typeResponsabiliteCac);
						}
					}
				);
			}
		);
	}
	
	tabHasChanged(tabChangeEvent: MatTabChangeEvent) {
		console.log('tabHasChanged: ', tabChangeEvent);
		if (tabChangeEvent.index === 0) {
			this.refreshCacTabCommand.next(typeResponsabiliteCac);
		} else if (tabChangeEvent.index === 1) {
			this.refreshCcTabCommand.next(typeResponsabiliteCc);
		}
	}
}
